<template>
  <section :class="['accordion__item', { 'accordion__item--active': active }]">
    <div class="accordion__item__title" @click="handleAccordionClick">
      <h3 v-html="title"></h3>
    </div>
    <div class="accordion__item__body">
      <p v-html="processedText"></p>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { handleFAQClick } from "@/services/gtm";

export default {
  props: ["title", "text"], // text com placeholders
  data() {
    return {
      active: false,
    };
  },
  methods: {
    handleAccordionClick() {
      handleFAQClick(this.title);
      this.active = !this.active;
    },
    replacePlaceholders(text, values) {
      if (!text || !values) return text;
      return text
        .replaceAll("{{valor_mensalidade}}", `${values.valor}`)
        .replaceAll("{{valor_clinicogeral}}", `${values.clinico_geral}`)
        .replaceAll("{{valor_demaisespecialidades}}", `${values.demais}`)
        .replaceAll("{{valor_anuidadetimes}}", `${values.anuidadeTimes}`)
        .replaceAll(
          "{{valor_anuidadetimes_12X}}",
          `${(Number(values.anuidadeTimes.replace(",", ".")) / 12)
            .toFixed(2)
            .toString()
            .replace(".", ",")}`
        );
    },
  },
  computed: {
    ...mapGetters(["cdtPrices"]), // Obtém os valores da store
    processedText() {
      // Processa o texto com os placeholders substituídos
      return this.replacePlaceholders(this.text, this.cdtPrices);
    },
  },
};
</script>

<style lang="scss">
.accordion {
  &__item {
    border-bottom: 1px solid rgba(255, 255, 255, 0.35);
    text-align: left;

    &--active {
      .accordion__item__body {
        padding-bottom: 20px;
        max-height: 1000px;
      }

      .accordion__item__title::after {
        transform: translateY(-50%) rotate(180deg);
      }
    }

    &__body {
      max-height: 0px;
      overflow: hidden;
      transition: 0.4s ease-in-out;

      p {
        color: $color-lightgray;
        font-family: "Lato", sans-serif;
        font-size: 15px;
        line-height: 22px;
      }
    }

    &__title {
      position: relative;
      padding: 18px 36px 18px 0;
      cursor: pointer;

      // Seta do colapse: triangulo em CSS, gira 180deg quando o item abre.
      &::after {
        content: "";
        position: absolute;
        right: 6px;
        top: 50%;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 6px solid $color-lightgray;
        transition: transform 0.3s ease-in-out;
      }

      &:hover h3 {
        color: #fff;
      }

      @include media(">=tablet") {
        padding: 22px 40px 22px 0;
      }

      h3 {
        color: $color-lightgray;
        font-family: "Lato", sans-serif;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        text-decoration: none;
        transition: color 0.3s ease-in-out;
        cursor: pointer;

        @include media(">=tablet") {
          font-size: 16px;
        }

        strong {
          font-weight: 700;
          margin: 0 2px;
        }
      }
    }
  }
}
</style>
